import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { formatFilterLabelText } from "./formatFilterLabel";

interface DocumentImportedFilterLabelProps {
    filters: Pick<FiltersTypes, "isImported" | "isImporting" | "isNotImported">;
}

export const DocumentImportedFilterLabel: React.FC<
    DocumentImportedFilterLabelProps
> = ({ filters: { isImported, isImporting, isNotImported } }) => {
    const parts: string[] = [];
    if (isImported) {
        parts.push("Imported");
    }
    if (isImporting) {
        parts.push("Importing");
    }
    if (isNotImported) {
        parts.push("Not imported");
    }
    return <>{formatFilterLabelText(parts, "Import statuses")}</>;
};

interface DocumentReconciledFilterLabelProps {
    filters: Pick<
        FiltersTypes,
        "isDocReconciled" | "isDocReconciling" | "isDocNotReconciled"
    >;
}

export const DocumentReconciledFilterLabel: React.FC<
    DocumentReconciledFilterLabelProps
> = ({
    filters: { isDocReconciled, isDocReconciling, isDocNotReconciled },
}) => {
    const parts: string[] = [];
    if (isDocReconciled) {
        parts.push("Reconciled");
    }
    if (isDocReconciling) {
        parts.push("Reconciling");
    }
    if (isDocNotReconciled) {
        parts.push("Not reconciled");
    }
    return <>{formatFilterLabelText(parts, "Reconciliation statuses")}</>;
};

interface DocumentMatchedFilterLabelProps {
    filters: Pick<FiltersTypes, "isDocMatched" | "isDocNotMatched">;
}

export const DocumentMatchedFilterLabel: React.FC<
    DocumentMatchedFilterLabelProps
> = ({ filters: { isDocMatched, isDocNotMatched } }) => {
    const parts: string[] = [];
    if (isDocMatched) {
        parts.push("Matched");
    }
    if (isDocNotMatched) {
        parts.push("Not matched");
    }
    return <>{formatFilterLabelText(parts, "Statuses")}</>;
};
